import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatBottomSheetModule } from '@angular/material';

import { BottomPopupComponent } from './bottom-popup.component';
import { BottomPopupService } from './bottom-popup.service';
import { DragDropModule } from '@angular/cdk/drag-drop';

@NgModule({
  exports: [BottomPopupComponent],
  declarations: [BottomPopupComponent],
  imports: [DragDropModule, MatBottomSheetModule, CommonModule],
  entryComponents: [BottomPopupComponent]
})
export class BottomPopupModule { }
